import { Stack } from 'components/Stack';
import styled from 'styled-components';
import { StackProps } from 'components/Stack';
import { Text } from 'components/Typography';

import { ReactComponent as IconBoxFlat } from 'constants/icon/icon_box_flat.svg';

type MessageLayoutProps = {
  titleComponent: React.ReactNode;
  messageComponent: React.ReactNode;
  buttonComponent?: React.ReactNode;
};

const MessageLayout = ({ titleComponent, messageComponent, buttonComponent }: MessageLayoutProps) => {
  return (
    <Stack
      style={{
        minWidth: 649,
        minHeight: 1008,
        padding: 20,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <MessageLayoutWrapper>
        {titleComponent}
        {messageComponent}
        {buttonComponent}
      </MessageLayoutWrapper>
    </Stack>
  );
};

export default MessageLayout;

const MessageLayoutWrapper = styled.div<StackProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid var(--RG06, #d8ddea);
  background: #fff;

  /* popup_2 */
  box-shadow: 0px 8px 20px 0px rgba(16, 30, 115, 0.1);
`;
